<template>
  <div class="article-detail-wrap">
    <div class="content">
      <div
         v-if="detail.type==='TITLE'"
         :style="{marginBottom:`${detail.containerStyle.marginBottom}px`}"
         class="title">
        {{ detail.title }}
      </div>
      <div
         v-if="detail.type==='SUB_TITLE'"
         :style="{marginBottom:`${detail.containerStyle.marginBottom}px`}"
         class="sub-title">
        {{ detail.subTitle }}
      </div>
      <div
         v-if="detail.type==='TEXT'"
         :style="{marginBottom:`${detail.containerStyle.marginBottom}px`}"
         class="text">
          {{detail.text}}
      </div>
      <div
        v-if="detail.type==='IMAGE'"
        class="image"
        :style="{marginBottom:`${detail.containerStyle.marginBottom}px`}">
        <img :src="detail.image" style="width: 100%;"/>
      </div>
      <div
        v-if="detail.type==='IMAGES'"
        class="images"
        :style="{marginBottom:`${detail.containerStyle.marginBottom}px`}">
        <a-carousel autoplay>
          <div :key="item" v-for="item in detail.images">
            <img :src="item" style="width: 100%;"/>
          </div>
        </a-carousel>
      </div>
      <div
        v-if="detail.type==='VIDEO'"
        class="video"
        :style="{marginBottom:`${detail.containerStyle.marginBottom}px`}">
        <video
          v-if="detail.video && detail.type==='VIDEO'"
          :src="detail.video"
          style="width: 100%"/>
      </div>

      <article-series
          v-if="detail.type ==='SERIES' "
          :id="detail.targetId"
      />

    </div>
    <div class="article-detail-operation">
      <a-icon type="edit" class="operate-button" @click="edit"/>
      <a-icon type="arrow-up" class="operate-button" @click="up"/>
      <a-icon type="arrow-down" class="operate-button" @click="down"/>
      <a-icon type="close" class="operate-button" @click="remove"/>
    </div>
  </div>
</template>

<script>
import ArticleSeries from './ArticleSeries.vue'

export default {
  name: 'ArticleDetailWrap',
  components: { ArticleSeries },
  props: {
    detail: Object,
  },
  methods: {
    up() {
      this.$emit('onUp');
    },
    down() {
      this.$emit('onDown');
    },
    edit() {
      this.$emit('edit');
    },
    remove() {
      this.$emit('onRemove');
    },
  },
};
</script>

<style scoped>
.article-detail-operation {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  background: #00000073;
  justify-content: center;
  align-items: center;
}

.article-detail-wrap {
  background: #ffffff;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  padding-right: 20px;
  padding-left: 20px;
}

.article-detail-wrap:hover .content {
  filter: blur(1px);
}

.article-detail-wrap:hover .article-detail-operation {
  display: flex;
}

.operate-button:hover {
  transform: scale(1.4);
}

.operate-button {
  margin: 5px;
  transition: transform .3s ease-in-out;
  will-change: transform;
  color: #ffffff;
}

.title {
  color: rgba(136, 112, 76, 1);
  font-size: 24px;
  line-height: 29px;
}

.text{
  color: rgba(136, 112, 76, 1);
  font-size: 12px;
  line-height: 22px;
  white-space: pre-line;
}

</style>
